<template>
  <div>
    <div class="head">
      <img src="/img/logo圆角.png" width="50" height="50" class="img1" />
      <div class="span1">MP3 Converter - Video Compressor</div>
    </div>
    
    <div class="subject">
      <div class="div22">
        <p class="p1">
          Video to MP3 Converter,Fast compress videos, reduce video size.<br>
          Convert MP4 to MP3,extract MP3 audio from video.Reduce video size, shrink video, save your device's storage space.<br />
          With the Fastest video to mp3 converter, You can convert video files to audio files (MP3, AAC) with various options ( bitrate, meta data) ,<br>You can extract high quality mp3 songs from video FAST.
        </p>
        
        <span class="span07">
          <h2>Powerful converter with many options：</h2>
          <br />
          <br />
          <ul class="ul">
            <li>Cut and compress video. </li>
            <li>Video to MP3 converter, can extract MP3 from video file.</li>
            <li>Sound Boost to increase the volume.</li>
            <li>Fast forward and compress video.</li>
            <li>Audio Merger.</li>
            <li>Support MP4, MKV, FLV, AVI, WMV, etc for videos.</li>
            <li>Support mp3, wav, ogg, m4a, acc, flac etc for audios.</li>
            <li>Free and Easy-to-use.</li>
          </ul>
        </span>
        <img src="/img/横幅.png" width="650px" height="317.7px" class="img3" />
      </div>
      
      <div class="div022">
        <span class="span08">
          <h3>Convert Audio : Image Compressor, support quickly batch compress images, save your storage space.</h3>
        </span>

        <div class="divtt">
          <div class="carousel-container">
            <div class="carousel-item" v-for="(img, index) in carouselImages" :key="index" :class="{ active: currentSlide === index }">
              <img :src="img" width="340" height="560.033" />
            </div>
          </div>
        </div>

        <div class="divts">
          <p>
            Audio cutter & Ringtone Maker<br>
            With MP3 Cutter & Ringtone Maker, you can easily trim music, merge music, mix music and accurately<br>
            cut out the tuneful part of music and set it as a unique ringtone for every contact. Customizing<br>
            your own alarm/notification is also viable.<br>
            <br>
          </p>
          <br>
          <p>
            ALL in one media converter<br>
            Cut and trim video to the length you need. Instagram story cutter. Export video in HD quality.<br>
            Easy-to-use video cutter app.<br>
            <br><br>
          </p>
          <p>
            Video to MP3 Converter<br>
            Video to mp3 converter , Video cutter , Mp3 cutter in one . Easily extract audio from your video<br>
            files . Extract high quality mp3 songs using this powerful application . Make ringtone from your<br>
            favorite song using mp3 cutter . Video to MP3 Converter uses ffmpeg and libmp3lame as library .<br>
          </p>
          <p>
            MP3 Video Converter<br>
            'Video MP3 Converter' is a fastest MP3 converter and cutter for Android. You can convert, cut,<br>
            resize, and create ringtone fast and easy! You can now change album cover of your music!<br>
            <br><br>
          </p>
          <p>
            Video to MP3 Converter is the best audio cutter and mp4 to mp3 converter for android. It's simple,<br>
            powerful, and totally FREE.Compress video to very small size, freeing up a lot of memory space on<br>
            your device. No duration limit.Download it now to save more space!
          </p>
        </div>
      </div>
    </div>
    
    <div class="div4">
      Copyright &copy; 2022.videotomusic.com All rights reserved
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const currentSlide = ref(0)
const carouselImages = [
  '/img/展示图 – 3.png',
  '/img/展示图 – 4.png',
  '/img/展示图 – 5.png',
  '/img/展示图 – 5.png',
  '/img/展示图 –2-4.png'
]

let intervalId = null

onMounted(() => {
  // 自动轮播
  intervalId = setInterval(() => {
    currentSlide.value = (currentSlide.value + 1) % carouselImages.length
  }, 4000)
})

onUnmounted(() => {
  if (intervalId) {
    clearInterval(intervalId)
  }
})
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.head {
  width: auto;
  min-height: 70px;
  font-size: 20px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
}

.img1 {
  margin-left: 19%;
  margin-top: 3px;
}

.span1 {
  margin-left: 20px;
  font-weight: bold;
}

.subject {
  width: auto;
  min-height: 1420px;
  border-top: 2px solid azure;
  background-color: #ffffff;
}

.div22 {
  height: 620px;
}

.p1 {
  margin-top: 30px;
  margin-left: 380px;
  line-height: 50px;
  padding-top: 20px;
}

.span07 {
  display: inline-block;
  margin-top: 40px;
  margin-left: 380px;
}

.ul {
  line-height: 30px;
  margin-left: 20px;
}

.img3 {
  margin-left: 850px;
  margin-top: -320px;
}

.div022 {
  height: 800px;
  background-color: #f9fafc;
}

.span08 {
  display: inline-block;
  margin-top: 50px;
  margin-left: 370px;
  font-size: 20px;
}

.divtt {
  margin-top: 80px;
  margin-left: 410px;
}

.carousel-container {
  position: relative;
  width: 340px;
  height: 560.033px;
  overflow: hidden;
}

.carousel-item {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.carousel-item.active {
  opacity: 1;
}

.carousel-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.divts {
  height: 550px;
  width: auto;
  margin-top: -510px;
  margin-left: 840px;
  line-height: 20px;
  font-size: 18px;
}

.div4 {
  height: 6%;
  width: auto;
  background-color: #525560;
  color: #fff;
  padding: 15px;
  font-size: 16px;
  line-height: -4%;
  text-align: center;
  margin: 0px;
}

@media screen and (max-width: 1023px) {
  .div4 {
    height: auto;
    width: auto;
    background-color: #525560;
    color: #fff;
    padding: 15px;
    font-size: 16px;
    text-align: center;
    margin: 0px;
  }
  
  .p1 {
    margin-left: 20px;
    margin-right: 20px;
  }
  
  .span07 {
    margin-left: 20px;
  }
  
  .img3 {
    display: none;
  }
  
  .divtt {
    margin-left: 10px;
  }
  
  .divts {
    margin-left: 20px;
    margin-top: 20px;
  }
}

@media screen and (min-width: 412px) {
  .div4 {
    height: auto;
    width: auto;
    background-color: #525560;
    color: #fff;
    padding: 15px;
    font-size: 16px;
    text-align: center;
    margin: 0px;
  }
}
</style> 